import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'custom-input',
  standalone: true,
  imports: [],
  templateUrl: './custom-input.component.html',
  styleUrl: './custom-input.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class CustomInputComponent {
  @Input() title: string = '';
}
